<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>抵押贷款周期设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';

export default {
  name: 'cycleProject',
  data() {
    return {
      updated: ''
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('cycle', ['pagination'])
  },
  methods: {
    ...mapActions('cycle', [
      'getList',
      'getCoinTypeList',
      'freshData',
      'getIdamount'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
